const overrides = (palette, typography) => ({
  root: {
    padding: 24
  }
})

export default overrides
